/** Design tokens shared by overview insight cards */
export const C = {
  teal: '#0E9F7E',
  tealLight: '#ECFDF5',
  tealDark: '#065F46',
  slate: '#0F172A',
  slate2: '#1E293B',
  slate3: '#64748B',
  slate4: '#94A3B8',
  border: '#E2E8F0',
  borderSubtle: '#F1F5F9',
  bg: '#F8FAFC',
  bg2: '#F1F5F9',
  white: '#FFFFFF',
  red: '#EF4444',
  redLight: '#FEF2F2',
  redDark: '#991B1B',
  amber: '#D97706',
  amberLight: '#FFFBEB',
  green: '#22C55E',
  greenLight: '#DCFCE7',
  greenDark: '#166534',
  blue: '#2563EB',
  blueLight: '#EFF6FF',
  purple: '#7C3AED',
  purpleLight: '#F5F3FF',
  peachBadgeBg: '#FFFBEB',
  peachBadgeFg: '#92400E',
  peachBadgeBorder: '#FDE68A',
  scoreBrown: '#78350F',
  scoreBrownMuted: '#A16207',
};

export const T = {
  cardHeader: {
    fontSize: '10px',
    fontWeight: 800,
    letterSpacing: '0.08em',
    color: C.slate3,
    textTransform: 'uppercase',
  },
  heroMetric: {
    fontSize: '34px',
    fontWeight: 900,
    lineHeight: 1,
    letterSpacing: '-0.02em',
  },
  chip: { height: 22, fontSize: '0.7rem', fontWeight: 800, borderRadius: '999px' },
  bodyPrimary: { fontSize: '12px', fontWeight: 700, color: C.slate2, lineHeight: 1.45 },
  bodySecondary: { fontSize: '12px', fontWeight: 600, color: C.slate3, lineHeight: 1.45 },
  rowLabel: { fontSize: '11px', color: C.slate4, fontWeight: 500 },
  rowValue: { fontSize: '12px', fontWeight: 700, color: C.slate2 },
  barLabel: { fontSize: '12px', color: C.slate3, fontWeight: 700 },
  barValue: { fontSize: '12px', color: C.slate2, fontWeight: 700, textAlign: 'right' },
  axisLabel: { fontSize: '11px', color: C.slate4, fontWeight: 600 },
  innerLabel: {
    fontSize: '10px',
    fontWeight: 800,
    color: C.slate4,
    letterSpacing: '0.08em',
  },
  cardTitle: {
    fontSize: '12px',
    fontWeight: 800,
    letterSpacing: '0.01em',
    color: C.slate2,
    textTransform: 'none',
    lineHeight: 1.35,
  },
  snapshotTitle: { fontSize: '12px', fontWeight: 700, color: C.slate2, lineHeight: 1.35 },
  snapshotMeta: { fontSize: '12px', fontWeight: 500, color: C.slate2, lineHeight: 1.45 },
  snapshotBody: { fontSize: '12px', fontWeight: 500, color: C.slate2, lineHeight: 1.5 },
};
